import React, { useCallback, useEffect, useState } from 'react';
import { buroApi } from './api';
import { CrearReporteModal, Cargando } from './BuroModales';
import { ChipEstatus, fechaCorte, mensajeError, mesCorto, money0, ultimoDia } from './helpers';
import { useAdminToast } from '../shell/AdminToastContext';
import './buro-reportes.css';

/*
 * P1 · Lista de reportes por mes. Clic en una fila abre el reporte (la URL la
 * maneja BuroPage vía onOpen). "Crear reporte" arma el borrador del mes y lo abre.
 */
export const BuroReportes = ({ onOpen }) => {
  const toast = useAdminToast();
  const [reportes, setReportes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [creando, setCreando] = useState(false); // modal abierto
  const [armando, setArmando] = useState(null);  // texto del loader

  const cargar = useCallback(async (signal) => {
    setLoading(true);
    setError(null);
    try {
      const lista = await buroApi.getReportes(signal);
      if (signal?.aborted) return;
      setReportes(lista);
    } catch (e) {
      if (signal?.aborted || e?.code === 'ERR_CANCELED') return;
      setError(mensajeError(e, 'No se pudieron cargar los reportes.'));
    } finally {
      if (!signal?.aborted) setLoading(false);
    }
  }, []);

  useEffect(() => {
    const ctrl = new AbortController();
    cargar(ctrl.signal);
    return () => ctrl.abort();
  }, [cargar]);

  const crear = async (tipo, mes) => {
    setCreando(false);
    setArmando('Armando los contratos…');
    try {
      const r = await buroApi.crearReporte(tipo, ultimoDia(mes));
      toast?.current?.show({ severity: 'success', summary: 'Ok', detail: `Reporte de ${mesCorto(mes)} creado` });
      onOpen(r.id);
    } catch (e) {
      toast?.current?.show({ severity: 'error', summary: 'Error', detail: mensajeError(e, 'No se pudo crear el reporte.') });
    } finally {
      setArmando(null);
    }
  };

  const botonCrear = (
    <button type="button" className="bu-btn bu-btn-primary" style={{ height: 38 }} onClick={() => setCreando(true)}>
      <i className="pi pi-plus" style={{ fontSize: 12 }} />Crear reporte
    </button>
  );

  return (
    <div className="buro-dash">
      <div className="bu-page">
        <div className="bu-head">
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <div className="bu-title">Buró de Crédito · Reporte mensual</div>
            <div className="bu-sub">Personas Físicas · Personas Morales y PFAE</div>
          </div>
          {botonCrear}
        </div>

        <div className="bu-card">
          {loading && reportes.length === 0 ? (
            <div className="bu-msg">Cargando reportes…</div>
          ) : error ? (
            <div className="bu-msg err">{error}</div>
          ) : reportes.length === 0 ? (
            <div className="bu-empty">
              <div className="bu-empty-ico"><i className="pi pi-file" /></div>
              <div style={{ maxWidth: 340 }}>Aún no hay reportes. Crea el primero eligiendo el mes.</div>
              {botonCrear}
            </div>
          ) : (
            <>
              <div className="bu-lista-row h">
                <div>Mes</div><div>Tipo</div><div>Estatus</div>
                <div className="r">Contratos</div><div className="r">Con error</div><div className="r">Saldo actual</div><div />
              </div>
              {reportes.map((r) => (
                <div key={r.id} className="bu-lista-row" onClick={() => onOpen(r.id)}>
                  <div style={{ fontWeight: 600 }} title={`Fecha de reporte ${fechaCorte(r.periodo)}`}>{mesCorto(r.periodo)}</div>
                  <div className="bu-sub">{r.tipo === 'pm_pfae' ? 'PM y PFAE' : 'PF'}</div>
                  <div><ChipEstatus estatus={r.estatus} /></div>
                  <div className="r tnum">{r.totales.contratos}</div>
                  <div className="r tnum" style={{ fontWeight: 600, color: r.totales.con_error ? '#B91C1C' : '#64748B' }}>{r.totales.con_error}</div>
                  <div className="r tnum">{money0(r.totales.saldo_actual)}</div>
                  <div className="r bu-sub"><i className="pi pi-angle-right" /></div>
                </div>
              ))}
            </>
          )}
        </div>
      </div>

      {creando && (
        <CrearReporteModal
          reportes={reportes}
          onClose={() => setCreando(false)}
          onCrear={crear}
          onAbrir={(r) => { setCreando(false); onOpen(r.id); }}
        />
      )}
      {armando && <Cargando texto={armando} />}
    </div>
  );
};

export default BuroReportes;
